import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=5f1311bc&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"
import style0 from "./Languages.vue?vue&type=style&index=0&id=5f1311bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1311bc",
  null
  
)

export default component.exports